import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { log } from '@/lib/logger';

const ViewportContext = createContext({
  mode: 'auto',
  setMode: () => {},
});

const applyViewportMeta = (mode) => {
  let tag = document.querySelector('meta[name="viewport"]');
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('name', 'viewport');
    document.head.appendChild(tag);
  }
  if (mode === 'desktop') {
    tag.setAttribute('content', 'width=1280, initial-scale=1.0');
    document.documentElement.dataset.viewportMode = 'desktop';
  } else if (mode === 'mobile') {
    tag.setAttribute('content', 'width=420, initial-scale=1.0');
    document.documentElement.dataset.viewportMode = 'mobile';
  } else {
    tag.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=5.0');
    delete document.documentElement.dataset.viewportMode;
  }
};

export function ViewportProvider({ children }) {
  const [mode, setModeState] = useState(() => {
    try { return localStorage.getItem('viewport_mode') || 'auto'; }
    catch { return 'auto'; }
  });

  useEffect(() => {
    applyViewportMeta(mode);
    try { localStorage.setItem('viewport_mode', mode); }
    catch (e) { log.debug('ViewportContext: localStorage.setItem failed', e); }
  }, [mode]);

  const setMode = useCallback((m) => setModeState(m), []);
  const value = useMemo(() => ({ mode, setMode }), [mode, setMode]);

  return (
    <ViewportContext.Provider value={value}>
      {children}
    </ViewportContext.Provider>
  );
}

export const useViewport = () => useContext(ViewportContext);
